import React from 'react';
import { Button } from '@material-ui/core';
import Fetcher, { URLBuild } from '../../services/fetcher';
import settings from '../../settings';

interface ConnectAsProps {
    email: string,    
}

const ConnectAs = (props: ConnectAsProps) => {
    return <>
        <Button color="primary" variant="contained" onClick={() => {
            Fetcher.get(URLBuild(`${settings.OpenIdProvider.users}/login/${props.email}`, {}))
                .then(r => {
                    window.location.assign(`${settings.frontUrl}login-as?refreshToken=${r.refreshToken}&accessToken=${r.accessToken}&expiresAt=${r.expiresAt}`)
                })
        }}>Switch user</Button>
    </>
}

export default ConnectAs;